export const QUERY_NAME = 'jwmCategoryOptions';

export const ITEMS_PER_PAGE = 200;
